module.exports = {
  fr: {
    meta: {
      title: "Devis chauffeur privé à Lyon | Davoyage",
      description: "Demandez votre devis gratuit de chauffeur privé à Lyon : aéroport, gare, stations de ski, vignobles. Proposition par email en quelques minutes."
    },
    eyebrow: "Réservation",
    title: "Obtenez un devis pour votre transport privé",
    lead: "Remplissez le formulaire, vous recevez votre devis par email en quelques minutes.",
    reassurance: ["Gratuit et sans engagement", "Devis par email en quelques minutes", "Paiement sécurisé en ligne"],
    stepsTitle: "Comment ça se passe",
    steps: [
      { title: "Votre devis par email", text: "Une proposition détaillée arrive dans votre boîte mail en quelques minutes." },
      { title: "Vous réservez en ligne", text: "Vous confirmez et réglez en ligne, par paiement sécurisé." },
      { title: "Votre chauffeur vous appelle", text: "Il prépare le trajet avec vous avant le départ." }
    ],
    contactTitle: "Mise à disposition, groupe ou demande particulière ?",
    contactText: "Appelez-nous ou écrivez-nous, nous vous répondons directement."
  },
  en: {
    meta: {
      title: "Private driver quote in Lyon | Davoyage",
      description: "Get a free private driver quote in Lyon: airport, station, ski resorts, vineyards. Proposal by email within minutes."
    },
    eyebrow: "Booking",
    title: "Request a price quote",
    lead: "Fill in the form and receive your quote by email within minutes.",
    reassurance: ["Free, no commitment", "Quote by email within minutes", "Secure online payment"],
    stepsTitle: "How it works",
    steps: [
      { title: "Your quote by email", text: "A detailed proposal reaches your inbox within minutes." },
      { title: "Book online", text: "Confirm and pay online with secure payment." },
      { title: "Your driver calls you", text: "They prepare the trip with you before departure." }
    ],
    contactTitle: "Hourly hire, group or special request?",
    contactText: "Call or write to us and we will answer you directly."
  },
  ru: {
    meta: {
      title: "Расчет стоимости частного водителя в Лионе | Davoyage",
      description: "Бесплатный расчет стоимости поездки с частным водителем в Лионе: аэропорт, вокзал, горнолыжные курорты, виноградники. Предложение по e-mail за несколько минут."
    },
    eyebrow: "Бронирование",
    title: "Запрос цены",
    lead: "Заполните форму, и через несколько минут вы получите расчет стоимости по e-mail.",
    reassurance: ["Бесплатно и без обязательств", "Расчет по e-mail за несколько минут", "Безопасная онлайн-оплата"],
    stepsTitle: "Как это работает",
    steps: [
      { title: "Расчет стоимости по e-mail", text: "Подробное предложение придет на вашу почту в течение нескольких минут." },
      { title: "Бронирование онлайн", text: "Вы подтверждаете заказ и оплачиваете его онлайн через защищенный платеж." },
      { title: "Водитель вам позвонит", text: "Он заранее обсудит с вами детали поездки." }
    ],
    contactTitle: "Почасовая аренда, группа или особый запрос?",
    contactText: "Позвоните или напишите нам, мы ответим напрямую."
  }
};
